<template>
    <div class="the-footer">
        <p>关于|帮助|条款|反馈</p>
        <p>Copyright @2021</p>
    </div>
</template>

<script>
    export default {
        name: "TheFooter"
    }
</script>

<style scoped lang="scss">
    @import "../../assets/css/the-footer";
</style>